import PropTypes from "prop-types";
import React from "react";
import { withRouter } from "tools/routerCompat";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import {AppInsightsTracker, MDialog} from "../../components/Shared";
import { getSearchParameter } from "../../components/Shared/Functions";
import MGrid, { COL_CODE_FULL_NAME, COL_CODE_EMAIL, ACTION_CONFIGURE, ACTION_REFRESH, ACTION_ADD } from "components/Shared/MGrid.tsx";
import { DATA_TYPE_BOOLEAN } from "typeConstants/dataTypes";
import { savePreference, loadPreference } from "../../actions/preferences";
import { getInternetUserList } from "../../actions/user";
import MSplitter from "components/Shared/MSplitter.tsx";
import {CreateUser, InternetUser} from "../../containers/User";

const CUSTOM_CELL = value => {
  if (typeof value === "object")
    return <div style={{ textAlign: "center" }}>{value.value}</div>;
  else return value;
};

const gridCols = [
  {
    key: "username",
    name: "User Name",
    width: 300,
    dataSource: "username",
    resizable: true
  },
  { code: COL_CODE_EMAIL, dataSource: "email", resizable: true },
  { code: COL_CODE_FULL_NAME, dataSource: "fullName", resizable: true },
  {
    key: "roleName",
    name: "Role",
    width: 200,
    dataSource: "roleName",
    resizable: true
  },
  {
    key: "failedAttempts",
    name: "Failed Attempts",
    width: 120,
    dataSource: "failedAttempts",
    resizable: true,
    dataType: CUSTOM_CELL
  },
  {
    key: "mustChangePassword",
    name: "Must Change Password",
    width: 170,
    dataSource: "mustChangePassword",
    resizable: true,
    dataType: DATA_TYPE_BOOLEAN
  },
  {
    key: "isDisabled",
    name: "Disabled",
    width: 90,
    dataSource: "isDisabled",
    resizable: true,
    dataType: DATA_TYPE_BOOLEAN
  },
];

class InternetUserList extends AppInsightsTracker {
  constructor(props) {
    super(props);
    this.onRowClick = this.onRowClick.bind(this);
    this.navigateToUserPage = this.navigateToUserPage.bind(this);
    this.showAddUserDialog = this.showAddUserDialog.bind(this);
    this.hideAddUserDialog = this.hideAddUserDialog.bind(this);
    this.state = {
      internetUserId: null
      , displayAddUserDialog: false
    };
  }

  componentDidMount() {
    const { location } = this.props;
    this.props.getInternetUserList(getSearchParameter(location));
    this.state = {
      internetUserId: null
      , displayAddUserDialog: false
    };
  }

  onRowClick(rowIndex) {
    let row = this.props.internetUserList[rowIndex];
    this.setState({ internetUserId: row.internetUserId });
  }

  navigateToUserPage() {
    this.props.history.push({
      pathname: "/user-profile",
    });
  }

  hideAddUserDialog(){
    this.setState({displayAddUserDialog: false});
  }

  showAddUserDialog() {
    this.setState({displayAddUserDialog: true});
  }

  render() {
    return (<>
      <MSplitter
        firstChild={
          <div className="padding-page-content full-height">
            <Card className="full-height">
              <MGrid
                configurationId="InternetUserList"
                headerText="User List"
                columnDefinitions={gridCols}
                data={this.props.internetUserList}
                isFetchingData={this.props.isFetchingInternetUserList}
                actions={[ACTION_CONFIGURE, ACTION_REFRESH, { code: ACTION_ADD, onClick: this.showAddUserDialog }]}
                preferences={this.props.preferences}
                loadPreference={this.props.loadPreference}
                savePreference={this.props.savePreference}
                onRowClick={this.onRowClick}
                displayNumOfItemsFound={true}
              />
            </Card>
          </div>}
        secondChild={this.state.internetUserId && <InternetUser internetUserOverride={this.state.internetUserId} verticalDisplay />}
        secondChildTitle={{
          title: "Internet User Profile",
          buttons: [
            { icon: "fullscreen", onClick: this.navigateToUserPage },
            { icon: "close", onClick: () => this.setState({ internetUserId: null }) }
          ]
        }}
        />
        <MDialog
            visible={this.state.displayAddUserDialog}
            width={600}
            height={"flex"}
            focusOnMount={false}
            >
            <CreateUser
                onCancelClicked={this.hideAddUserDialog}
            />

        </MDialog>
        </>
    );
  }
}

InternetUserList.propTypes = {
  getInternetUserList: PropTypes.func.isRequired,
  isFetchingInternetUserList: PropTypes.bool.isRequired,
  internetUserList: PropTypes.array,
  preferences: PropTypes.object,
  loadPreference: PropTypes.func,
  savePreference: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    internetUserList: state.user.internetUserList,
    isFetchingInternetUserList: state.user.isFetchingInternetUserList,
    preferences: state.preferences,
  };
};

const mapDispatchToProps = dispatch => ({
  getInternetUserList(search) {
    dispatch(getInternetUserList(search));
  },
  savePreference(code, value) {
    dispatch(savePreference(code, value));
  },
  loadPreference(code) {
    dispatch(loadPreference(code));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InternetUserList));

